import React, { useState } from 'react';
import { ChevronDown, X } from 'lucide-react';

import { Colors } from '@/components/phone/theme';

/**
 * The movements list under the stock cards.
 *
 * Every movement in the store is a long list, so it starts folded and opens
 * on its own when an item is picked — the page remounts it on selection, which
 * is what resets the fold. The clear control sits in the body rather than the
 * header because the header is itself a button.
 */
export default function PhoneMovements({ title, aside, defaultOpen, onClear, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section
      className="mt-3 rounded-[14px] border"
      style={{ backgroundColor: Colors.background.primary, borderColor: Colors.border.default }}
      data-testid="phone-movements"
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="flex h-12 w-full items-center justify-between gap-2 px-4 text-left"
      >
        <span className="flex min-w-0 items-baseline gap-2">
          <span className="text-[15px] font-bold" style={{ color: Colors.text.primary }}>{title}</span>
          {!!aside && <span className="truncate text-[11px]" style={{ color: Colors.text.tertiary }}>{aside}</span>}
        </span>
        <ChevronDown className={`h-4 w-4 shrink-0 transition-transform ${open ? '' : '-rotate-90'}`} style={{ color: Colors.text.secondary }} />
      </button>
      {open && (
        <div className="border-t" style={{ borderColor: Colors.border.subtle }}>
          {onClear && (
            <button
              type="button"
              onClick={onClear}
              className="flex h-11 w-full items-center justify-center gap-1.5 border-b text-[13px] font-semibold"
              style={{ borderColor: Colors.border.subtle, color: Colors.accent.DEFAULT }}
            >
              <X className="h-3.5 w-3.5" /> Show all movements
            </button>
          )}
          {children}
        </div>
      )}
    </section>
  );
}
